export const photoCaptureGetFraudWarningReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { fraudStatement: action.payload.fraudStatement, isFraudWarningApiStatus: action.payload.status });
};
//# sourceMappingURL=photoCaptureGetFraudWarningReducer.js.map